import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import ProposalPreparationPage from "./components/ProposalPreparation/ProposalPreparationPage";
//import SectionRevision from "./components/App_ProjectWriting/SectionRevision";
//import InformationAccess from "./components/App_InformationAccess/InformationAccess";
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth } from './firebase';
import ChatPage from './components/IdeaChat/ChatPage';
import LoginPage from './components/LoginPage';
import { TailSpin } from 'react-loader-spinner';
import ProjectWritingInputs from "./components/ProjectWriting/ProjectWritingInputs";
import SectionsWriting from "./components/ProjectWriting/SectionsWriting";
import ProjectWritingUser from "./components/ProjectWriting/ProjectWritingUser";
import UnverifiedNoticePage from './components/UnverifiedNoticePage';
import BuyCredits from './components/BuyCredits';
import MaintenancePage from './components/MaintenancePage'; // Import the new component
import CreditCheck from "./components/CreditCheck";
import RedeemCode from "./components/RedeemCode";


{/*function App() {
  return (
    <Router>
        <Routes>
          <Route path="/" element={<ChatPage />} />
          <Route path="/ProjectWriting" element={<ProjectWriting />} />
          <Route path="/SectionRevision" element={<SectionRevision/>} />
          <Route path="/InformationAccess" element={<InformationAccess />} /> 
        </Routes>
    </Router>
  );
}
export default App;*/}

function App() {
  const [user, loading] = useAuthState(auth);
  const isMaintenanceMode = false; 

  if (loading){
    return (
      <div>
      <div className="loading-container">
        <TailSpin
          height={80}
          width={80}
          color="#003c96"
          ariaLabel="writing-spinner"
        />
      </div></div>);
  }

  return (
    <Router>
      <Routes>
      {isMaintenanceMode ? (
                // If in maintenance mode, all paths show the MaintenancePage
                <Route path="*" element={<MaintenancePage />} />
              ) : (
                <>
                <Route
                  path="*"
                  element={<Navigate to={user ? (user.emailVerified ? "/chat" : "/verify") : "/login"} />}
                />
                
                <Route
                  path="/login"
                  element={!user ? <LoginPage /> : user.emailVerified ? <Navigate to="/chat" /> : <Navigate to="/verify" />}
                />

                <Route
                  path="/verify"
                  element={user && !user.emailVerified ? <UnverifiedNoticePage /> : <Navigate to="/chat" />}
                />

                <Route
                  path="/chat"
                  element={user && user.emailVerified ? <ChatPage /> : <Navigate to={user ? "/verify" : "/login"} />}
                />

                <Route
                  path="/project_preparation"
                  element={user && user.emailVerified ? <ProposalPreparationPage /> : <Navigate to={user ? "/verify" : "/login"} />}
                />

                <Route
                  path="/project_writing_inputs"
                  element={user && user.emailVerified ? <ProjectWritingInputs /> : <Navigate to={user ? "/verify" : "/login"} />}
                />

                <Route
                  path="/sections_writing"
                  element={user && user.emailVerified ? <SectionsWriting /> : <Navigate to={user ? "/verify" : "/login"} />}
                />

                <Route
                  path="/project_writing_user"
                  element={user && user.emailVerified ? <ProjectWritingUser /> : <Navigate to={user ? "/verify" : "/login"} />}
                />

                <Route
                  path="/buy_credits"
                  element={user && user.emailVerified ? <BuyCredits /> : <Navigate to={user ? "/verify" : "/login"} />}
                />

                <Route
                  path="/credit_checker"
                  element={user && user.emailVerified ? <CreditCheck /> : <Navigate to={user ? "/verify" : "/login"} />}
                />

                <Route
                  path="/redeem_code"
                  element={user && user.emailVerified ? <RedeemCode /> : <Navigate to={user ? "/verify" : "/login"} />}
                />
          </>
        )}

      </Routes>
    </Router>
  );
}

export default App;
